/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1TutoraiConfigPersonaMutationRequest,
  PutApiV1TutoraiConfigPersonaMutationResponse,
  PutApiV1TutoraiConfigPersona400,
  PutApiV1TutoraiConfigPersona401,
  PutApiV1TutoraiConfigPersona500,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigPersona.ts";

function getPutApiV1TutoraiConfigPersonaUrl() {
  const res = { method: "PUT", url: `/api/v1/tutorai/config/persona` as const };
  return res;
}

/**
 * @description Salva a persona. `isGlobal=true` substitui a persona global. `isGlobal=false` com `classStudentId` salva a persona da turma. **(Requer Authorization para autenticação)**
 * @summary Atualizar persona do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/persona}
 */
export async function putApiV1TutoraiConfigPersona(
  data?: PutApiV1TutoraiConfigPersonaMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1TutoraiConfigPersonaMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1TutoraiConfigPersonaMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigPersona400
      | PutApiV1TutoraiConfigPersona401
      | PutApiV1TutoraiConfigPersona500
    >,
    PutApiV1TutoraiConfigPersonaMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1TutoraiConfigPersonaUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
